const POPULAR_FILTER = 'popular';

export const SITEMAP_FILTERS: ReadonlyArray<string> = [
  POPULAR_FILTER, 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
] as const;

export function isTranslatableFilter(filter: string): boolean {
  const TRANSLATABLE_FILTERS = [POPULAR_FILTER] as const;
  return (TRANSLATABLE_FILTERS as readonly string[]).includes(filter);
}